import Settings from 'settings';
/**
 * 加载资源：css、img、link、script等等
 * 性能：白屏时间、dom渲染耗时、页面加载耗时等等
 * 
 * 在页面加载完成之后上传 监控数据 数组
 */
import router from '@/router/index'

// const SendUrl = process.env.VUE_APP_API_PERFORMANCE // https:www.xx.com

const monitor = { // 监控
  performance: null, // 性能
  resources: [], // 资源
}

export const performanceLog = ()=>{
	/**
	 * 在页面加载完后上报性能数据
	 */
	// window.addEventListener('load',()=>{
		if(window.requestIdleCallback) { // 如果浏览器支持这个方法，利用这个方法迁移页面性能数据
		  window.requestIdleCallback(() => {
		    monitor.performance = getPerformance()
		    monitor.resources = getResources()
		    savePerformance()
		  })
		} else {
		  setTimeout(function() {
		    monitor.performance = getPerformance()
		    monitor.resources = getResources()
		    savePerformance()
		  }, 0)
		}
	// })
}

/**
 * 获取页面加载的时间性能信息
 */
function getPerformance() {
  if (!window.performance) return
  const timing = window.performance.timing
  return {
    dns: timing.domainLookupEnd - timing.domainLookupStart, // DNS解析时间
    tcp: timing.connectEnd - timing.connectStart,
    whiteScreen: timing.responseStart - timing.navigationStart, // 白屏时间
    // redirect: timing.redirectEnd - timing.redirectStart, // 重定向耗时
    dom: timing.domContentLoadedEventEnd - timing.navigationStart, // dom渲染耗时
    load: timing.loadEventEnd - timing.navigationStart, // 页面加载耗时
    // unload: timing.unloadEventEnd - timing.unloadEventStart, // 页面卸载耗时
    request: timing.responseEnd - timing.requestStart, // 请求耗时
    time: new Date().toLocaleString(), // 获取性能信息时当前时间
	router: router.app._route.fullPath
  }
}

/**
 * 获取页面资源加载的时间性能信息
*/
function getResources() {
  if (!window.performance) return
  const data = window.performance.getEntriesByType('resource')
  const resources = {
    css: [],
    img: [],
    script: [],
    xmlhttprequest: [],
    link: [],
    fetch: [],
    iframe: [],
    other: [],
    time: new Date().toLocaleString()
  }
  data.forEach(item => {
    let key = resources[item.initiatorType]?item.initiatorType:'other'
    resources[key].push({
      name: item.name, // 资源的名称
      duration: item.duration.toFixed(2), // 资源加载耗时
      size: item.transferSize, // 资源大小
      protocol: item.nextHopProtocol, // 资源所用协议
    })
  })
  return resources
}

function savePerformance(){
    // console.log(`thy:当前页面：${monitor.performance.router}`)
    // console.log(`thy:dom渲染耗时：${monitor.performance.dom}`)
    // console.log(`thy:白屏时间：${monitor.performance.whiteScreen}`)
    // console.log(`thy:页面加载耗时：${monitor.performance.load}`)
    // console.log(`thy:加载请求耗时：${monitor.performance.request}`)
    const bmUrl = Settings.present.bm?Settings.present.bm=='/'?Settings.baseURL(): Settings.present.bm:Settings.baseURL()
    console.log(`thy:`, monitor)
    console.log('thy:', bmUrl)
	  navigator.sendBeacon(`${ bmUrl }/report`, JSON.stringify(monitor.performance))
}
